export default function PasswordStrength({ password }) {
  const checks = {
    length: password.length >= 8,
    lowercase: /[a-z]/.test(password),
    uppercase: /[A-Z]/.test(password),
    number: /\d/.test(password),
    special: /[^A-Za-z0-9]/.test(password),
  };

  const score = Object.values(checks).filter(Boolean).length;

  const strengthMap = {
    0: { label: "", color: "" },
    1: { label: "Very Weak", color: "auth-strength-1" },
    2: { label: "Weak", color: "auth-strength-2" },
    3: { label: "Fair", color: "auth-strength-3" },
    4: { label: "Good", color: "auth-strength-4" },
    5: { label: "Strong", color: "auth-strength-5" },
  };

  const { label, color } = strengthMap[score];

  if (!password) return null;

  return (
    <div className="auth-password-strength">
      <div className="auth-strength-bar-wrap">
        <div
          className={`auth-strength-bar ${color}`}
          style={{ width: `${(score / 5) * 100}%` }}
        />
      </div>
      <p className="auth-strength-label">
        Strength: <span className="auth-strength-value">{label}</span>
      </p>
      <ul className="auth-strength-rules">
        <li className={checks.length ? "auth-rule-ok" : ""}>At least 8 characters</li>
        <li className={checks.uppercase ? "auth-rule-ok" : ""}>One uppercase letter</li>
        <li className={checks.lowercase ? "auth-rule-ok" : ""}>One lowercase letter</li>
        <li className={checks.number ? "auth-rule-ok" : ""}>One number</li>
        <li className={checks.special ? "auth-rule-ok" : ""}>One special character</li>
      </ul>
    </div>
  );
}
